import axios from 'axios'
import { API_BASE_PATH } from '../Config/Config'
import {useMutation} from '@tanstack/react-query'

const deleteApp = async ({ appVersion, productId }) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);
  
  const response = await axios.post(`${API_BASE_PATH}/KeyLogging/product/delete/${productId}`, {
    appVersion: appVersion
  });
  return response;
}

const useDeleteAppMutation = (options = {}) => {
    return useMutation({
        mutationFn: deleteApp,
        ...options
    })
}

export default useDeleteAppMutation;